export enum EErrorKeys {
  LINE_SUSPENDED = 'LINE_SUSPENDED',
  TEMPORAL_BLACKLIST = 'TEMPORAL_BLACKLIST',
  PERMANENT_BLACKLIST = 'PERMANENT_BLACKLIST',
  MAX_DAY_ATTEMPTS = 'MAX_DAY_ATTEMPTS',
  TIME_OUT = 'TIME_OUT',
  EMPTY_PACKAGE = 'EMPTY_PACKAGE',
  BIN_NOT_WITHELISTED = 'BIN_NOT_WITHELISTED',
  SHORT_LINK_ERROR = 'SHORT_LINK_ERROR',
  INVALID_MSISDN = 'INVALID_MSISDN',
  DEFAULT = 'DEFAULT'
}
